import { Smartphone, Search, Ticket, Trophy, Star, Crosshair } from 'lucide-react';
import useScrollReveal from '../hooks/useScrollReveal';

const steps = [
  {
    num: '1',
    icon: <Smartphone size={36} />,
    title: 'Accéder à l\'app',
    desc: 'Accedez à TIGOO gratuitement sur votre smartphone en quelques secondes.',
  },
  {
    num: '2',
    icon: <Search size={36} />,
    title: 'Explorez les pronostiqueurs',
    desc: 'Parcourez le classement des meilleurs pronostiqueurs, filtre par sport et performance.',
  },
  {
    num: '3',
    icon: <Ticket size={36} />,
    title: 'Recevez vos coupons',
    desc: 'Suivez vos pronostiqueurs favoris et recevez leurs coupons des leur publication.',
  },
  {
    num: '4',
    icon: <Trophy size={36} />,
    title: 'Profitez des resultats',
    desc: 'Utilisez les coupons et suivez vos gains grace aux statistiques detaillees.',
  },
];

function Step({ step, index }) {
  const [ref, isVisible] = useScrollReveal();
  return (
    <div
      className={`step-card ${isVisible ? 'visible' : ''}`}
      ref={ref}
      style={{ animationDelay: `${index * 0.15}s` }}
    >
      <div className="step-num">{step.num}</div>
      <div className="step-icon">{step.icon}</div>
      <h3>{step.title}</h3>
      <p>{step.desc}</p>
      {index < steps.length - 1 && <div className="step-connector"></div>}
    </div>
  );
}

export default function HowItWorks() {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section id="how-it-works">
      <div className={`how-header reveal ${isVisible ? 'visible' : ''}`} ref={ref}>
        <span className="section-label">Comment ça marche</span>
        <h2 className="section-title">
          Commencez en<br /><span className="title-highlight">4 étapes simples</span>
        </h2>
        <p className="section-sub">Que vous soyez parieur ou pronostiqueur, TIGOO s'adapte a vos besoins.</p>
      </div>

      <div className="how-tabs">
        <div className="tab-header">
          <span className="tab-badge parieur-badge"><Crosshair size={14} style={{ marginRight: 6 }} /> Pour les parieurs</span>
        </div>
      </div>

      <div className="steps-grid">
        {steps.map((s, i) => (
          <Step key={i} step={s} index={i} />
        ))}
      </div>

      <div className="how-prono-box">
        <div className="prono-box-inner">
          <div className="prono-box-icon"><Star size={40} /></div>
          <div className="prono-box-text">
            <h3>Vous êtes pronostiqueur ?</h3>
            <p>
              Partagez vos coupons, construisez votre reputation et montrez votre talent.
              Votre classement evolue en fonction de vos resultats réels.
            </p>
          </div>
          <a href="#cta" className="btn-primary btn-sm">Dévenir pronostiqueur →</a>
        </div>
      </div>
    </section>
  );
}
